import { Add } from '@mui/icons-material';
import { useNewCustomerButtonStyles } from './new-customer-button.styles';
import { Button, useMediaQuery, useTheme } from '@mui/material';

export function NewCustomerButton({ onClickBack }: { onClickBack(): void }) {
  const classes = useNewCustomerButtonStyles();
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.down('sm'));

  if (isXs) {
    return (
      <Button color="secondary" className={classes.card} onClick={onClickBack}>
        <Add />
      </Button>
    );
  } else {
    return (
      <Button color="secondary" startIcon={<Add />} className={classes.card} onClick={onClickBack}>
        New customer
      </Button>
    );
  }
}
